import BaseFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/BaseFormElement";
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";

export default class FormElementScale extends BaseFormElement {
	useCustomRange: boolean = false
	max: number = 10
	lowLabel: string = ""
	highLabel: string = ""

	constructor(title, isRequired) {
		super(FormElementType.SCALE, title, isRequired);
	}

	resetElement() {
		super.resetElement()
		this.answer = null
		this.max = 10
		this.useCustomRange = false
		this.lowLabel = "Low"
		this.highLabel = "High"
	}

	setGlobalScaleConfig(scaleConfig = {}) {
		this.normalizeAnswer()
		if (!this.useCustomRange) {
			this.max = scaleConfig.max || 10
		}
		return this
	}

	normalizeAnswer() {
		if (this.answer === "") {
			this.answer = null
		}
	}

	_calculateAnswerScoreAsTotal() {
		return Number(this.answer) || 0
	}

	calculateMaxScore() {
		return this.max
	}
}
